module.exports = __webpack_public_path__ + "static/media/meteor.64c57863.svg";